import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Calendar, Users, Search } from 'lucide-react';
import { toast } from 'sonner';

const FloatingBookingBar = () => {
  const navigate = useNavigate();
  const [checkIn, setCheckIn] = useState('');
  const [checkOut, setCheckOut] = useState('');
  const [guests, setGuests] = useState(2);

  const handleSearch = () => {
    if (!checkIn || !checkOut) {
      toast.error('Please select check-in and check-out dates');
      return;
    }
    navigate(`/rooms?checkIn=${checkIn}&checkOut=${checkOut}&guests=${guests}`);
  };

  return (
    <div className="floating-booking-bar glass shadow-2xl" data-testid="floating-booking-bar">
      {/* Desktop Layout */}
      <div className="hidden md:flex items-center gap-4 rounded-full p-2 pl-6">
        <div className="flex items-center gap-2 flex-1">
          <Calendar size={20} style={{ color: '#1A3C34' }} className="flex-shrink-0" />
          <input
            type="date"
            value={checkIn}
            onChange={(e) => setCheckIn(e.target.value)}
            className="bg-transparent border-none outline-none text-sm font-medium w-full min-w-0"
            style={{ color: '#1A202C' }}
            data-testid="check-in-input"
          />
        </div>
        <div className="w-px h-8 flex-shrink-0" style={{ background: '#E5E7EB' }} />
        <div className="flex items-center gap-2 flex-1">
          <Calendar size={20} style={{ color: '#1A3C34' }} className="flex-shrink-0" />
          <input
            type="date"
            value={checkOut}
            onChange={(e) => setCheckOut(e.target.value)}
            className="bg-transparent border-none outline-none text-sm font-medium w-full min-w-0"
            style={{ color: '#1A202C' }}
            data-testid="check-out-input"
          />
        </div>
        <div className="w-px h-8 flex-shrink-0" style={{ background: '#E5E7EB' }} />
        <div className="flex items-center gap-2 flex-1">
          <Users size={20} style={{ color: '#1A3C34' }} className="flex-shrink-0" />
          <select
            value={guests}
            onChange={(e) => setGuests(parseInt(e.target.value))}
            className="bg-transparent border-none outline-none text-sm font-medium"
            style={{ color: '#1A202C' }}
            data-testid="guests-select"
          >
            {[1, 2, 3, 4, 5, 6].map((num) => (
              <option key={num} value={num}>
                {num} {num === 1 ? 'Guest' : 'Guests'}
              </option>
            ))}
          </select>
        </div>
        <button
          onClick={handleSearch}
          className="w-12 h-12 rounded-full flex items-center justify-center hover:scale-105 active:scale-95 transition-all flex-shrink-0"
          style={{ background: '#1A3C34' }}
          data-testid="search-button"
        >
          <Search size={20} style={{ color: 'white' }} />
        </button>
      </div>

      {/* Mobile Layout */}
      <div className="md:hidden rounded-2xl p-4">
        <div className="grid grid-cols-2 gap-3 mb-3">
          <div className="flex items-center gap-2 p-3 rounded-xl" style={{ background: 'rgba(255,255,255,0.5)' }}>
            <Calendar size={18} style={{ color: '#1A3C34' }} className="flex-shrink-0" />
            <input
              type="date"
              value={checkIn}
              onChange={(e) => setCheckIn(e.target.value)}
              className="bg-transparent border-none outline-none text-xs font-medium w-full"
              style={{ color: '#1A202C' }}
              placeholder="Check-in"
            />
          </div>
          <div className="flex items-center gap-2 p-3 rounded-xl" style={{ background: 'rgba(255,255,255,0.5)' }}>
            <Calendar size={18} style={{ color: '#1A3C34' }} className="flex-shrink-0" />
            <input
              type="date"
              value={checkOut}
              onChange={(e) => setCheckOut(e.target.value)}
              className="bg-transparent border-none outline-none text-xs font-medium w-full"
              style={{ color: '#1A202C' }}
              placeholder="Check-out"
            />
          </div>
        </div>
        <div className="flex items-center gap-3">
          <div className="flex items-center gap-2 p-3 rounded-xl flex-1" style={{ background: 'rgba(255,255,255,0.5)' }}>
            <Users size={18} style={{ color: '#1A3C34' }} className="flex-shrink-0" />
            <select
              value={guests}
              onChange={(e) => setGuests(parseInt(e.target.value))}
              className="bg-transparent border-none outline-none text-xs font-medium flex-1"
              style={{ color: '#1A202C' }}
            >
              {[1, 2, 3, 4, 5, 6].map((num) => (
                <option key={num} value={num}>
                  {num} {num === 1 ? 'Guest' : 'Guests'}
                </option>
              ))}
            </select>
          </div>
          <button
            onClick={handleSearch}
            className="h-12 px-6 rounded-full flex items-center justify-center gap-2 hover:scale-105 active:scale-95 transition-all"
            style={{ background: '#1A3C34' }}
          >
            <Search size={18} style={{ color: 'white' }} />
            <span className="text-white text-sm font-medium">Search</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default FloatingBookingBar;
